/**
 * GSAP global setup — was an inline <script> right after animations.min.js
 * in theme.liquid. Extracted so animations.min.js / inertia-plugin.min.js
 * can be `defer` (they were parser-blocking, ~180 KB on the critical path).
 * Loaded with `defer` AFTER those two, so plugin order is preserved and
 * `gsap` is defined by the time this runs. Every academy section boots on
 * DOMContentLoaded / load, i.e. after all deferred scripts, so nothing
 * needs GSAP before this file executes.
 */
(function () {
  if (typeof gsap === 'undefined') return;

  gsap.defaults({ ease: window.Power4 ? Power4.easeOut : 'power4.out' });
  gsap.config({ nullTargetWarn: false });

  var plugins = [];
  ['ScrollTrigger', 'DrawSVGPlugin', 'SplitText', 'CustomEase', 'InertiaPlugin', 'Flip'].forEach(function (name) {
    if (typeof window[name] !== 'undefined') plugins.push(window[name]);
  });
  if (plugins.length) gsap.registerPlugin.apply(gsap, plugins);

  if (typeof CustomEase !== 'undefined' && !CustomEase.get('osmo-ease')) {
    CustomEase.create('osmo-ease', '0.625, 0.05, 0, 1');
  }

  if (typeof ScrollTrigger !== 'undefined') {
    // Mobile address bar fires `resize` on height-only change → ScrollTrigger
    // would re-measure every trigger mid-scroll (pin/parallax bounds slip
    // under the finger). ignoreMobileResize suppresses exactly that; a real
    // width change / rotation still refreshes.
    ScrollTrigger.config({ ignoreMobileResize: true });

    // Safari (desktop) only: fast scrolling through a pinned section can
    // overshoot the pin point and visibly snap back — Safari's own
    // scroll-event dispatch runs out of sync with rAF during a fast fling,
    // so ScrollTrigger's pin can react a frame or more late. normalizeScroll
    // replaces the browser's native scroll with GSAP's own rAF-synced one,
    // which is GSAP's documented fix for exactly this Safari pin jank.
    // Scoped to Safari via UA sniff (not applied globally) since it changes
    // how ALL scrolling on the page behaves — Chrome/Firefox don't have
    // this desync and don't need the trade-off.
    var ua = window.navigator.userAgent;
    var isSafari = /^((?!chrome|android).)*safari/i.test(ua) && !/Mobi|iPhone|iPad|iPod/i.test(ua);
    if (isSafari && ScrollTrigger.normalizeScroll) {
      ScrollTrigger.normalizeScroll(true);
    }
  }

  // After a frame hang >500ms the ticker catches up at most 33ms at once
  // instead of jumping the lost time — prevents scroll-linked tweens from
  // "snapping" after GC pauses / tab switches.
  if (gsap.ticker && gsap.ticker.lagSmoothing) gsap.ticker.lagSmoothing(500, 33);
})();
